<template>
  <div>
    <md-dialog :md-active.sync="createDialog" v-on:md-closed="closed">
      <div class="content-dialog">
        <div class="loading-overlay" v-if="!loadDialog">
          <md-progress-spinner :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <md-card-header>
          <div class="md-title">Создание пользователя</div>
        </md-card-header>
        <form class="md-layout">
          <md-card class="md-layout-item">
            <md-card-content>
              <div class="md-layout md-gutter">
                <div class="md-layout">
                  <div class="md-layout-item">
                    <label for="company">Укажите компанию, обязательное поле *</label>
                    <CompanySearch name="company" v-on:setCompany="setCompany"/>
                  </div>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('user_name')">
                    <label for="user_name">Логин</label>
                    <md-input name="user_name" id="user_name" autocomplete="given-name" v-model="form.name" required maxlength="255"/>
                    <div class="md-error" v-if="!this.$v.form.name.required">{{ t('user.create.required') }}</div>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('email')">
                    <label for="email">E-mail</label>
                    <md-input name="email" id="email" autocomplete="given-name" v-model="form.email" maxlength="255"/>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter" v-if="this.isRuRegion">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('inn')">
                    <label for="inn">ИНН</label>
                    <md-input name="inn" id="inn" autocomplete="given-name" v-model="form.inn" required maxlength="255"/>
                    <div class="md-error" v-if="!this.$v.form.inn.required">{{ t('user.create.required') }}</div>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field>
                    <label for="user_type">Тип</label>
                    <md-select v-model="form.role_id" name="role_id" id="role_id" @md-selected="changeUsersFilter" md-dense required>
                      <md-option v-for="(item, index) in roles"
                                 :value="index"
                                 :key="index">{{ item }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>

              <div class="md-layout md-gutter">
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('last_name')">
                    <label for="last_name">Фамилия</label>
                    <md-input name="last_name" id="last_name" autocomplete="family-name" v-model="form.last_name" maxlength="16"/>
                  </md-field>
                </div>
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('first_name')">
                    <label for="first_name">Имя</label>
                    <md-input name="first_name" id="first_name" autocomplete="family-name" v-model="form.first_name" maxlength="16"/>
                  </md-field>
                </div>
                <div class="md-layout-item ">
                  <md-field :class="getValidationClass('middle_name')">
                    <label for="middle_name">Отчество</label>
                    <md-input name="middle_name" id="middle_name" autocomplete="family-name" v-model="form.middle_name" maxlength="16"/>
                  </md-field>
                </div>
              </div>

              <md-field>
                <label for="status">Статус</label>
                <md-select v-model="form.status_id" name="status" id="status">
                  <md-option value="1" :key="'status_1'">Активный</md-option>
                  <md-option value="0" :key="'status_2'">Неактивный</md-option>
                </md-select>
              </md-field>
            </md-card-content>
            <md-card-actions>
              <md-button class="ct-yellow pointer" @click="createDialog = false">Закрыть</md-button>
              <md-button class="md-primary ct-green pointer" @click="submitCreateForm">Создать</md-button>
            </md-card-actions>
          </md-card>
        </form>
      </div>
    </md-dialog>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import HttpClient from '@/api/calls'
import Responses from '@/api/responses'
import { required, requiredIf, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import CompanySearch from '../common/forms/CompanySearch.vue'

export default {
  components: { CompanySearch },
  name: 'usersCreate',
  mixins: [validationMixin],
  data: () => ({
    form: {
      name: null,
      role_id: 5,
      status_id: 1,
      company_id: null,
      inn: null,
      last_name: null,
      first_name: null,
      middle_name: null,
      email: null
    },
    roles: null,
    default_role: 5,
    userRole: [],
    successCreate: false,
    sending: false,
    createDialog: true,
    loadDialog: false,
    userData: {},
    name_search: null,
    country_code: 'ru',
    searchDisable: true,
    submitStatus: 'OK'
  }),
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(4)
      },
      inn: {
        required: requiredIf(function () {
          return this.isRuRegion
        }),
        numeric,
        minLength: minLength(12),
        maxLength: maxLength(12)
      },
      first_name: {
        required: requiredIf(function () {
          return this.isRuRegion
        })
      },
      last_name: {
        required: requiredIf(function () {
          return this.isRuRegion
        })
      },
      middle_name: {
        required: requiredIf(function () {
          return this.isRuRegion
        })
      }
    }
  },
  computed: {
    isRuRegion () {
      return this.country_code === 'ru'
    }
  },
  methods: {
    setCompany (shopId) {
      this.form.company_id = shopId
    },
    changeUsersFilter () {
      this.$emit('changeUsersFilter')
    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]
      if (field && this.sending === true) {
        return {
          'md-invalid': field.$invalid || field.$dirty
        }
      }
    },
    checkCopyFrom () {
      this.searchDisable = this.form.copy_from_other !== '1'
    },
    prepareFilters () {
      this.changeFilter()
      let params = {}
      params['page'] = 0
      params['filter'] = this.$store.state.filtersShop
      return params
    },
    submitCheck () {
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.submitStatus = 'OK'
      }
    },
    submitCreateForm () {
      this.sending = true
      this.$v.$touch()
      this.submitCheck()

      for (let field in this.form) {
        if (this.form.hasOwnProperty(field)) {
          this.getValidationClass(field)
          this.userData[field] = this.form[field]
        }
      }

      if (this.submitStatus !== 'OK') {
        return
      }
      if (this.country_code === 'ru') {
        this.userData['country_id'] = 3
      } else {
        this.userData['country_id'] = 2
      }

      this.startLoading()
      HttpClient.httpPost(['users.create'], this.userData)
        .then(() => {
          Responses.successRspMessage('Выполнено успешно', 'Создание пользователя')
          this.successCreate = true
          // this.$store.commit('setFilter', {name: 'name', value: 'deleteFilter'})
          // this.$store.commit('setFilter', {name: 'q', value: 'deleteFilter'})
          // this.$emit('changeFilter')
          this.stopLoading()
          this.createDialog = false
          this.$emit('closeCreateDialogSuccess')
        })
        .catch(err => {
          this.stopLoading()
          console.log(err)
        })
    },
    changeFilter () {
      this.$store.commit('setFilter', {name: 'name', value: this.name_search})
      this.$store.commit('setFilter', {name: 'q', value: this.name_search})
      this.$emit('changeFilter')
    },
    startLoading () {
      this.loadDialog = false
    },
    stopLoading () {
      this.loadDialog = true
    },
    closed () {
      if (this.successCreate === true) {
        this.$emit('closeCreateDialogSuccess')
      } else {
        this.$emit('closeCreateDialog')
      }
      this.successCreate = false
    }
  },
  created () {
    if (this.$store.state.createDialog !== 1) {
      this.createDialog = false
      return false
    }
    this.roles = this.$store.state.roles
    this.country_code = this.$store.state.filtersUsers.country_code
    // this.country_code = 'kz'
    this.createDialog = true
    this.stopLoading()
  }
}
</script>

<style lang="scss" scoped>
  .md-dialog {
    z-index: 5;
    min-width: 900px;
    max-height: 800px;
    overflow: no-display;
  }
  .md-card {
    margin: 1px;
    padding: 1px;
    display: inline-block;
    vertical-align: top;
  }
  .loading-overlay {
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 450px;
    background: none;
    position: absolute;
    z-index: 20 !important;
  }

  .md-button.ct-green {
    background-color: green !important;
  }

  .md-button.ct-yellow {
    background-color: #e29641 !important;
  }

  .md-button.ct-red {
    background-color: #e91e63 !important;
  }

  .pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/UsersCreate.vue